/** Event posters step — gallery folders & copy (BMS DIY style). */

export const HORIZONTAL_BANNER_SLOTS = 4;
export const BANNER_MAX_MB = 1;
export const GALLERY_DESC_MAX = 110;

export const GALLERY_FOLDER_OPTIONS = [
  "F&B",
  "BTS",
  "Past Events",
  "Vibe Check",
  "Venue",
  "Facilities Around",
  "Rides",
  "Artists",
];

export const emptyLandscapeSlots = () =>
  Array.from({ length: HORIZONTAL_BANNER_SLOTS }, () => "");

export function ensureLandscapeSlots(images = []) {
  const next = [...(images || [])].slice(0, HORIZONTAL_BANNER_SLOTS);
  while (next.length < HORIZONTAL_BANNER_SLOTS) next.push("");
  return next;
}

export function emptyGalleryFolders() {
  return GALLERY_FOLDER_OPTIONS.map((folder) => ({
    folder,
    images: [],
    videos: [],
  }));
}
